// extracted by mini-css-extract-plugin
module.exports = {"typeFilters":"style_typeFilters__2KMn0","selected":"style_selected__1uG6S"};